<template>
  <div class="training-feeling">
    <div
      v-for="item in getFeelTypeOptions()"
      :key="'feeling-' + item.type"
      :class="['feeling-item', { myself: isMyself, active: feelType === item.type }]"
    >
      <div
        class="img-box"
        @click="changeFeelType(item.type)"
      >
        <img :src="assetsRequire(item.imgSrc)" />
        <img :src="assetsRequire(item.activeImgSrc)" />
      </div>
      <div class="name">
        <span>{{ item.nameText }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, getCurrentInstance } from 'vue';
import { Message } from '@arco-design/web-vue';
import { activityDetailStore } from '@client/store/activityDetailStore';
import { assetsRequire } from '@client/helper';
import { getFeelTypeOptions } from '@client/config/feeling';

const vm = getCurrentInstance();
Message._context = vm?.appContext;
const t = vm.proxy.$root.$t;
const activityDetailStoreRef = activityDetailStore();
const feelType = computed(() => activityDetailStoreRef.feelType);
const isMyself = computed(() => activityDetailStoreRef.isMyself);
async function changeFeelType(feelType) {
  if (activityDetailStoreRef.isMyself && activityDetailStoreRef.labelId) {
    activityDetailStoreRef.$patch({ feelType });
  }
  const res = await activityDetailStoreRef.saveTrainingNoteAndFeeling();
  if (res) Message.success(t('R4030'));
}
</script>

<style lang="scss" scoped>
@import '@client/styles/_mixins.scss';

.training-feeling {
  padding: 16px;
  box-sizing: border-box;

  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: space-between;

  .feeling-item {
    width: 25%;
    display: flex;
    flex-direction: column;

    &.myself {
      .img-box {
        cursor: pointer;
      }
    }

    &.active {
      .img-box {
        img {
          &:nth-of-type(1) {
            visibility: hidden;
          }
          &:nth-of-type(2) {
            visibility: visible;
            z-index: 2;
          }
        }
      }

      .name {
        color: rgba(255, 255, 255, 1);
      }
    }

    .img-box {
      flex-grow: 0;
      flex-shrink: 0;
      position: relative;
      width: 32px;
      height: 32px;
      line-height: 0;
      font-size: 0;
      margin: auto;
      margin-bottom: 12px;

      img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        transform-origin: center center;
        visibility: hidden;

        &:nth-of-type(1) {
          visibility: visible;
          z-index: 2;
        }
        &:nth-of-type(2) {
          visibility: hidden;
        }
      }
    }

    .name {
      flex-grow: 1;
      flex-shrink: 1;
      text-align: center;
      font-size: 12px;
      font-weight: 400;
      color: rgba(255, 255, 255, 0.6);
      line-height: 14px;

      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>
